import type { ParentType as Parent_Type_Enum } from '@risksmart-app/domain/src/types/consts/parent-type';
import type { CustomRibbonFilters } from '@risksmart-app/domain/src/types/custom-ribbon-filter';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface UpsertCustomRibbonTRPCInput {
  ParentType: Parent_Type_Enum;
  Filters: CustomRibbonFilters;
  OriginalTimestamp?: string | null;
  /** Used by the GraphQL fallback update path only (not sent to tRPC) */
  Id?: string | null;
}

export const useUpsertCustomRibbonTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.customRibbon.upsert.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.customRibbon.byParentType.queryKey(),
        });
      },
    }),
  });
  const upsertCustomRibbon = async (input: UpsertCustomRibbonTRPCInput) => {
    await mutation.mutateAsync(input);
  };

  return {
    upsertCustomRibbon,
    loading: mutation.isPending,
    error: mutation.error,
  };
};
